import { instance } from '@/libs/api/instance'

/**
 *
 * @param params.name
 * @param params.iban
 * @param params.currency_id
 * @param params.search
 * @param params.page
 * @param params.sort
 * @param {object|null|string} params.expand
 * @param {object} [options] - Request cancellation options
 * @param {AbortSignal} [options.signal] - Cancels the request when aborted
 * @return {Promise<AxiosResponse<any>>}
 */
export const getList = async (params = {}, { signal } = {}) => {
  return instance.get('/v1/beneficiary', {
    params,
    signal,
  })
}
